import { memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDialog, useLegacyEffect } from "helper/customHook";
import { useDispatch, useSelector } from "react-redux";

import ViewTable from "modules/DeclareLeave/components/CustomTable";

import {
  listEmployeeArriveLateRequestSelector,
  selectListReasonArriveLate,
  totalRecordsEmployeeArriveLateRequestSelector,
} from "modules/DeclareLeave/redux/selector";
import { DIALOG } from "helper/enum/dialogEnum";

import { getReasonArriveLateStart } from "modules/DeclareLeave/redux/getReasonArriveLate";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";

import EmptyState from "components/common/EmptyState";

import pathRoutes from "routes/pathRoutes";
import useColumns from "./useColumn";
import ArriveLateDetails from "../Modals/ArriveLateDetail";
import { getListEmployeeArriveLateRequestStart } from "modules/DeclareLeave/redux/getListEmployeeArriveLateRequest";

export const ListArriveLate = memo(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { arriveLateCols: columns } = useColumns();
  const requestLeaveDialog = useDialog(
    DIALOG.VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL
  );

  const data = useSelector(listEmployeeArriveLateRequestSelector);
  const totalRecords = useSelector(
    totalRecordsEmployeeArriveLateRequestSelector
  );
  const listReasonArriveLate = useSelector(selectListReasonArriveLate);

  useLegacyEffect(() => {
    if (listReasonArriveLate.length === 0) {
      dispatch(getReasonArriveLateStart());
    }
  }, []);

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      requestLeaveDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.employeeOrderLeave}/${declareLeaveURL.lackOfTime}/${idRecord}`,
        { replace: true }
      );
    }
  };

  return (
    <>
      <ViewTable
        id="employeeArriveLateRequest"
        data={data ?? []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {
          dispatch(getListEmployeeArriveLateRequestStart());
        }}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn xin đi muộn/về sớm nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => {
          handleViewDetail(item.id);
        }}
        isHasMore={data?.length < totalRecords}
        height={500}
      />
      <ArriveLateDetails />
    </>
  );
});
